import { Component, OnInit } from '@angular/core';
import { ProjectsService} from '../../services/projects.service';

type projectType = Array<{id: number, title: string, note: string, isHidden: boolean, items: projectItemType}>;
type projectItemType = Array<{id: number, title: string, isChecked: boolean, isHidden: boolean, items?: projectItemType}>;
  
@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  selectedProject: number = 0;
  selectedProjectID: number = 0;

  orderedProject = -1;

  newProject = { 
    settings: 0,
    unit: "",
    title: ""
  };

  editedProject = {
    id: "",
    settings: 0,
    title: "",
    unit: "",
    idUser: localStorage.getItem("idUser"),
    state: 0
  };

  constructor(private projectService: ProjectsService) { }

  ngOnInit() {
    this.projectService.getProjects();
  }

  addProject(){
    if(this.projectService.addProject(this.newProject) == true){
      this.newProject.title = "";
    } 
  }

  editProject(i){
    this.editedProject.id = this.projectService.projects[i].id;
    this.editedProject.title = this.projectService.projects[i].title;
    this.editedProject.settings = this.projectService.projects[i].settings;
    this.editedProject.unit = this.projectService.projects[i].unit;

    this.selectedProject = i;
  }

  updateProject(){
    this.projectService.updateProject(this.editedProject, this.selectedProject);
  }

  removeProject(i, id){
    this.projectService.removeProject(i, id);
    
  }

  dropSuccess(i){
    this.orderedProject = -1;
    this.projectService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedProject = i;
  }

  dragEnd(){
    this.orderedProject = -1;
  }

  orderUp(i){
    this.projectService.orderUp(i);
  }
  orderDown(i){
    this.projectService.orderDown(i);
  }

}
 


// WEBPACK FOOTER //
// ./src/app/components/projects/projects.component.ts